import { render, staticRenderFns } from "./backup-settings-form.component.vue?vue&type=template&id=78047a7c"
import script from "./backup-settings-form.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-settings-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports